import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, TokensService } from '../services';
import { AlertService } from '../alert';

@Component({
  selector: 'app-password-change',
  providers: [TokensService],
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css']
})
export class PasswordChangeComponent implements OnInit {

  model: any = {};
  loading = false;

  constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private tokensService: TokensService,
        private alertService: AlertService) { }


  ngOnInit() {
  }

  changePwd() {
    if (this.model.password!=this.model.passwordConfirm) {
      this.alertService.error("Passwort und Bestätigungspasswort stimmen nicht überein");
      return;
    }
        this.loading = true;
        this.tokensService.changePwd(this.model.password)
            .subscribe(
            data => {
                this.router.navigate(['/#']);
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/password-change/password-change.component.ts